module.exports = __webpack_public_path__ + "assets/images/electoral-college/diverging-votes/tablet.svg?v=763c3c15";